

import React from 'react';

type SvgProps = {
    color: string;
    size?: number;
};

const Moon: React.FC<SvgProps> = ({ color, size }) => (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M26.1687 9.84742C22.1757 11.6812 19.4029 15.7153 19.4029 20.397C19.4029 25.0787 22.1757 29.1127 26.1687 30.9465C24.6964 31.6227 23.0581 31.9997 21.3318 31.9997C14.9238 31.9997 9.72913 26.805 9.72913 20.397C9.72913 13.989 14.9238 8.79425 21.3318 8.79425C23.0581 8.79425 24.6964 9.17126 26.1687 9.84742Z" fill={color} />
    </svg>
);

export default Moon;